<template>
  <div>
    <div class="home d-flex">
      <div class="intro-text d-flex align-items-end px-md-5">
        <div>
          <h1 v-html="$t('Obchodné priestory')"></h1>
          <p v-html="$t('Obchodné priestory v obytných domoch etáp Bory Nový Dvor a Bory Nádvorie sa nachádzajú v plne obývanej lokalite novej štvrte Bory, ktorá ponúka kompletnú občiansku vybavenosť. V bezprostrednej blízkosti sa nachádza Nemocnica Bory, nákupno-zábavné centrum Bory Mall a rozsiahla retailová zóna.')"></p>
          <b-button @click="scrollToMap" class="d-block d-md-inline-block" squared variant="primary">{{ $t('Pozrieť mapu') }}</b-button>
        </div>
      </div>
    </div>
    <section class="temp-block px-3 px-md-0 py-3">
      <div class="d-flex flex-wrap px-0 pl-md-5 pr-md-3 justify-content-between">
        <div class="col-12 col-lg-7 px-0">
          <div class="img"></div>
        </div>
        <div class="col-12 col-lg-4 mb-3 mb-lg-0 px-0 py-lg-5">
          <h2 class="mb-5">{{ $t('O štvrti Bory') }}</h2>
          <p class="mb-5" v-html="$t('Moderná štvrť presahujúca do mestských častí Lamač a Devínska Nová Ves. V štvrti sa nachádza plnohodnotná občianska vybavenosť v podobe Nemocnice Bory, nákupno-zábavného centra Bory Mall, retailovej zóny s väčšími obchodnými reťazcami a viac ako 1 500 dokončených bytov.')"></p>
          <b-button @click="scrollTo('home-map')" squared variant="primary">{{ $t('Pozrieť ponuku') }}</b-button>
        </div>
      </div>
    </section>
    <section class="px-3 px-md-0 py-3 temp-block dark-bg">
      <div class="d-flex flex-wrap px-0 pl-md-5 pr-md-3 justify-content-between mb-4">
        <div class="col-12 col-lg-4 mb-3 mb-lg-0 px-0 py-lg-5">
          <h2 class="mb-5">{{ $t('Obchodné priestory Bory Nový Dvor') }}</h2>
          <p class="mb-5" v-html="$t('Projekt Bory Nový Dvor ponúka 3 retailové priestory situované na prízemí rezidenčných budov už skolaudovanej etapy. Priestory sú dokončené, skolaudované a prístupné priamo z ulice, čo zabezpečuje jednoduchý a prirodzený kontakt s obyvateľmi a návštevníkmi štvrte.')"></p>
          <b-button @click="scrollTo('home-map')" squared variant="primary">{{ $t('Pozrieť ponuku') }}</b-button>
        </div>
        <div class="col-12 col-lg-7 px-0 priestory-slider">
          <slick
              ref="slickStandard"
              :options="slickOptions"
              class="slider-for"
          >
            <div class="slide">
              <img src="../assets/images/retail/05A.jpg" alt="">
            </div>
            <div class="slide">
              <img src="../assets/images/retail/05A.jpg" alt="">
            </div>
            <div class="slide">
              <img src="../assets/images/retail/05A.jpg" alt="">
            </div>
          </slick>
        </div>
      </div>
      <div class="d-flex flex-wrap px-0 pl-md-5 pr-md-3 justify-content-between">
        <div class="col-12 col-lg-7 px-0 priestory-slider">
          <slick
              ref="slickStandard2"
              :options="slickOptions"
              class="slider-for"
          >
            <div class="slide">
              <img src="../assets/images/retail/05A.jpg" alt="">
            </div>
            <div class="slide">
              <img src="../assets/images/retail/05A.jpg" alt="">
            </div>
            <div class="slide">
              <img src="../assets/images/retail/05A.jpg" alt="">
            </div>
          </slick>
        </div>
        <div class="col-12 col-lg-4 mb-3 mb-lg-0 px-0 py-lg-5">
          <h2 class="mb-5">{{ $t('Obchodné priestory Bory Nádvorie') }}</h2>
          <p class="mb-5" v-html="$t('Etapa Bory Nádvorie prinesie nové obchodné priestory v rámci rezidenčnej budovy, ktorá rozšíri štvrť Bory o ďalších 180 bytových jednotiek. Obchodné priestory sú navrhnuté tak, aby boli prístupné z ulice aj z vnútrobloku, ktorý je súčasťou projektu. Vďaka tomu dokážu pohodlne obslúžiť nielen rezidentov, ale aj návštevníkov a okoloidúcich v rámci centra štvrte.')"></p>
          <b-button @click="scrollTo('home-map')" squared variant="primary">{{ $t('Pozrieť ponuku') }}</b-button>
        </div>
      </div>
    </section>
    <HomeMap />
    <RetailTable />
  </div>
</template>

<script>
import zones from "@/data/retailZones.json"
import Slick from "vue-slick";
import RetailTable from "@/components/retail/RetailTable";
import HomeMap from "@/components/maps/HomeMap";
export default {
  name: "RetailZone",
  components: {Slick, RetailTable, HomeMap},
  data() {
    return {
      slickOptions: {
        infinite: true,
        adaptiveHeight: true,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        // Any other options that can be got from plugin documentation
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      },
    }
  },
  methods: {
    scrollToMap() {
      const map = document.getElementById('retailmap')
      map.scrollIntoView({behavior: "smooth", block: 'center'})

    }
  }
}
</script>

<style lang="sass" scoped>
$md: 768px
$lg: 1060px
.home
  background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/stvrt-mapa.jpg") bottom/cover no-repeat

  p
    margin-bottom: 30px
    max-width: 770px

.temp-block
  background: var(--darkBlue)

  &.dark-bg
    background: var(--text-dark)
  h2
    margin-bottom: 0
    @media (max-width: $md)
      margin-bottom: 30px
  p
    @media (max-width: $md)
      br
        display: none
  .img
    width: 100%
    height: 100%
    background: url("../assets/images/BH4-JESENNE-lowres-1037.jpg") no-repeat center
    background-size: cover
    @media (max-width: $md)
      min-height: 250px
      margin-bottom: 20px


.priestory-slider
  overflow: hidden

.retail-zone-map
  position: relative
  background: var(--darkBlue)

  .hand-icon
    right: 15px
    left: auto
    bottom: auto
    top: 85px

  .map
    @media (max-width: $md)
      display: flex
      flex-wrap: nowrap
      overflow-x: auto
      height: 460px
      -webkit-overflow-scrolling: touch
      position: relative

      &::-webkit-scrollbar
        display: none

  .zone-menu
    // position: absolute
    // right: 48%
    // top: 15%
    // z-index: 999
    display: flex
    padding: 15px 30px

    @media (max-width: $lg)
      display: flex
      flex-wrap: nowrap
      overflow-x: auto
      -webkit-overflow-scrolling: touch
      position: relative
      padding: 15px

      &::-webkit-scrollbar
        display: none

    .link
      display: block
      color: #fff
      padding: 12px 15px 12px 15px
      border-bottom: 1px solid #fff
      position: relative
      font-weight: 700
      cursor: pointer
      width: 33.333%

      @media (max-width: $md)
        font-size: 16px
        padding-right: 20px
        width: auto
        flex: 0 0 auto

      &:hover
        background: rgba(119, 185, 217, 0.2)
        border-bottom: 1px solid #77B9D9

      &.active
        color: #77B9D9
        background: rgba(119, 185, 217, 0.2)
        border-bottom: 2px solid #77B9D9

        &:hover
          border-bottom: 2px solid #77B9D9

.overlay
  background: url(../assets/images/retailmapbg.png) center/cover no-repeat
  overflow: hidden
  position: relative

  @media (max-width: $md)
    width: 260vw
    position: absolute
    left: -120px

.pins
  width: 100%
  height: 100%
  position: absolute
  left: 0
  top: 0
  z-index: 999
  pointer-events: none
  display: none
  transform: scale(1.25) translateX(-4%) translateY(-2%)

  &.active
    display: block

.pins-ready
  background: url(../assets/images/retailmap-vprevadzke_2.png) center/cover no-repeat

.pins-free
  background: url(../assets/images/retailmap-volne.png) center/cover no-repeat

.pins-preparing
  background: url(../assets/images/retailmap-vpriprave.png) center/cover no-repeat

svg
  max-width: 100%
  height: auto
  position: relative
  z-index: 99
  //transform: scale(1.305) translateX(27.8%) translateY(2.2%)
  transform: scale(1.65) translateX(24.7%) translateY(0.5%)

  g
    opacity: 0
    cursor: pointer

    &.object
      display: none

    &.active
      display: block

    &:hover
      opacity: inherit

.st0
  display: none

.st1
  display: inline
  fill: #192027

.st2
  display: inline
  opacity: 0.2
  fill: #D2D2D1

.st3
  display: inline
  fill: none
  stroke: #6C787B
  stroke-width: 3
  stroke-linecap: round
  stroke-linejoin: round
  stroke-miterlimit: 10

.st4
  display: inline
  fill: none
  stroke: #6C787B
  stroke-width: 3
  stroke-miterlimit: 10

.st5
  display: inline
  fill: none
  stroke: #6C787B
  stroke-width: 5
  stroke-miterlimit: 10

.st6
  display: inline
  fill: #FFFFFF
  stroke: #FFFFFF
  stroke-width: 3
  stroke-linecap: round
  stroke-linejoin: round
  stroke-miterlimit: 10

.st7
  display: inline
  fill: none
  stroke: #6C787B
  stroke-width: 4
  stroke-miterlimit: 10

.st8
  display: inline
  fill: none
  stroke: #6C787B
  stroke-width: 4
  stroke-linecap: round
  stroke-linejoin: round
  stroke-miterlimit: 10

.st9
  display: inline

.st10
  fill: none
  stroke: #6C787B
  stroke-width: 1.122

.st11
  fill: none
  stroke: #6C787B
  stroke-width: 1.002

.st12
  fill: #D2D2D1

.st13
  fill: none
  stroke: #EAD394
  stroke-width: 4
  stroke-miterlimit: 10

.st14
  fill: none
  stroke: #EAD394
  stroke-width: 4
  stroke-miterlimit: 10
  stroke-dasharray: 6.1294, 6.1294

.st15
  fill: none
  stroke: #EAD394
  stroke-width: 4
  stroke-miterlimit: 10
  stroke-dasharray: 5.9976, 5.9976

.st16
  fill: none
  stroke: #EAD394
  stroke-width: 4
  stroke-miterlimit: 10
  stroke-dasharray: 5.8613, 5.8613

.st17
  opacity: 0.8
  fill: #1db5ff

.st18
  display: none
  fill: #192027

.st19
  fill: #0283b5

.st20
  display: none
  fill: #FFFFFF
  stroke: #FFFFFF
  stroke-width: 3
  stroke-linecap: round
  stroke-linejoin: round
  stroke-miterlimit: 10


.st21
  fill: #414042

          </style>